import { useCallback } from 'react';

import { useSearchResults } from '#src/app/pages/searchV2/shared/searchState';

import { useFilterByNearYou } from './hooks/useFilterByNearYou';
import { useFilterByTrending } from './hooks/useFilterByTrending';
import { useFilterByVictories } from './hooks/useFilterByVictories';

type Result = ModelHookResult<
	{ isNearYouLoading: boolean },
	{
		filterByVictories: () => void;
		filterByNearYou: () => void;
		filterByTrending: () => void;
	}
>;

export function useExploreButtons(): Result {
	const {
		actions: { filterByVictories },
	} = useFilterByVictories();

	const {
		data: { isNearYouLoading },
		actions: { filterByNearYou },
	} = useFilterByNearYou();

	const {
		actions: { filterByTrending },
	} = useFilterByTrending();

	const results = useSearchResults();

	return {
		data: { isNearYouLoading },
		actions: {
			filterByVictories: useCallback(() => {
				if (results.isLoading) return;
				filterByVictories();
			}, [filterByVictories, results.isLoading]),
			filterByNearYou: useCallback(() => {
				if (results.isLoading) return;
				filterByNearYou();
			}, [filterByNearYou, results.isLoading]),
			filterByTrending: useCallback(() => {
				if (results.isLoading) return;
				filterByTrending();
			}, [results.isLoading, filterByTrending]),
		},
	};
}
